
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/funds/[alphabet]",
      function () {
        return require("private-next-pages/browse/funds/[alphabet].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/funds/[alphabet]"])
      });
    }
  